import {z} from 'zod';
import {webbillCostSpecificationsSchema} from './webbill-cost-specification.model';
import {zNumberToString} from '@brunata-angular/util';

const onlineCostSpecificationsSchema = z
    .object({
        costSpecificationId: zNumberToString,
        amount: z.number().nullable(),
        consumptionAmount: z.number().nullable(),
        consumptionCost: z.boolean(),
        consumptionUnit: z.string().nullable(),
        vat: z.string().nullable(),
        description: z.string().nullable(),
        calculatedByBrunata: z.boolean(),
        deleted: z.boolean(),
    })
    .transform(it => ({
        ...it,
        disabled: false,
    }));

export type OnlineCostSpecifications = z.infer<typeof onlineCostSpecificationsSchema>;

export const specificationSchema = z.object({
    costSpecification: onlineCostSpecificationsSchema.nullable(),
    webBillCostSpecification: webbillCostSpecificationsSchema.nullable(),
});
export type Specification = z.infer<typeof specificationSchema>;
